import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { gql, useLazyQuery } from '@apollo/client';

import { Groups, Groups_groups as Group, GroupsVariables } from '../graph-types/Groups';

const GET_GROUPS = gql`
  query Groups($client: String!) {
    groups(client: $client) {
      id
      name
    }
  }
`;

export { Group };

type Props = {
  clientId: string;
  value: Group | null;
  onSelect: (option: Group | null) => void;
};

export const GroupAutocomplete: React.FC<Props> = (props) => {
  const [open, setOpen] = useState<boolean>(false);
  const [getGroups, { loading, data, called }] = useLazyQuery<Groups, GroupsVariables>(GET_GROUPS, {
    variables: { client: props.clientId },
  });

  const options = data?.groups ?? [];

  useEffect(() => {
    if (open && !called) {
      getGroups();
    }
  }, [open, called, getGroups]);

  return (
    <Autocomplete
      id="groups-autocomplete"
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      onChange={(event, newValue) => {
        props.onSelect(newValue);
      }}
      getOptionSelected={(option, value) => option.id === value.id}
      getOptionLabel={(option) => {
        return option.name;
      }}
      options={props.value ? [props.value, ...options] : options}
      loading={loading}
      value={props.value}
      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth
          margin="dense"
          label="Group"
          variant="outlined"
          name="group-autocomplete"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};
